var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90779 0.0570359C11.4198 0.365721 12.398 1.85175 12.0919 3.37656C11.7859 4.90137 10.3123 5.88792 8.80034 5.57924C7.28681 5.269 6.30855 3.78452 6.61464 2.25816C6.92073 0.733351 8.39427 -0.2532 9.90779 0.0570359Z",
    fill: "#01426A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5576 3.54637C13.5499 3.58825 13.5468 3.63013 13.5391 3.67201C13.2992 4.86797 12.5885 5.84522 11.6411 6.45173C12.4009 7.48637 12.7193 8.87157 12.4255 10.3405C12.1348 11.7862 11.3027 12.9543 10.1906 13.6182C10.206 13.5577 10.2244 13.4987 10.2367 13.4367C10.5597 11.8235 9.52611 10.2506 7.92645 9.92482C6.32679 9.59908 4.76866 10.643 4.44411 12.2562C4.43642 12.2966 4.43334 12.3354 4.42565 12.3757C3.71042 11.3504 3.41663 9.99773 3.7058 8.56134C3.9919 7.13735 4.79481 5.98172 5.8715 5.31006C5.21318 4.3747 4.92247 3.17874 5.1655 1.96572C5.17165 1.93314 5.18242 1.90212 5.19011 1.87109C2.67218 2.83903 0.720281 5.05567 0.161937 7.83538C-0.264127 9.95585 0.157323 12.1182 1.3463 13.9253C2.53528 15.7324 4.34721 16.9641 6.44984 17.3938C6.97588 17.5008 7.51269 17.5551 8.04643 17.5551C11.8564 17.5551 15.1711 14.8203 15.9263 11.0525C16.497 8.20922 15.5079 5.40623 13.5576 3.54637Z",
    fill: "#01426A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcg);
export default __webpack_public_path__ + "static/media/ccg.6c54d0e7375891760f845f1c12575a8b.svg";
export { ForwardRef as ReactComponent };